var impressum = "Upplýsingar";
var privacy = "Persónuvernd og lagaleg málefni";
var recallInfo = "Innköllunarupplýsingar";
var signOut = "Skrá út";
var is_is = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { is_is as default, impressum, privacy, recallInfo, signOut };
